/** Shopify CDN: Minification failed

Line 16:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 16:49 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:548 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:798 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:1085 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:1281 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:1708 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:1862 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:1926 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:1928 Transforming default arguments to the configured target environment ("es5") is not supported yet
... and 8 more hidden warnings

**/
class MCartDrawer extends HTMLElement {
  constructor() {
      super(),
      this.cartDrawerInner = this.querySelector(".m-cart-drawer__inner"),
      this.cartDrawerCloseIcon = this.querySelector(".m-cart-drawer__close"),
      this.cartOverlay = this.querySelector(".m-cart__overlay"),
      this.rootUrl = window.Shopify.routes.root,
      this.setHeaderCartIconAccessibility(),

      this.cartDrawerCloseIcon.addEventListener("click", this.close.bind(this)),
      this.addEventListener("click", (t=>{
        t.target.closest(".m-cart-drawer__inner") !== this.cartDrawerInner && this.close()
      }
      ))
      window.cartDrawer = this;
      // P0.5: single cart fetch fans out to both messages; no per-helper /cart.js calls.
      this.refreshCartMessages();
      // bfcache restore: when user hits back from checkout / other page, the previous
      // DOM state restores (with possibly-stale header values). Silently reconcile
      // — _pzReconcileHeader is idempotent so no flash if values already match.
      window.addEventListener('pageshow', (e) => {
          if (e.persisted) this.refreshCartMessages();
      });
  }
  refreshCartMessages() {
      return fetch('/cart.js').then(r => r.json()).then(cart => {
          freeShippingMsg(cart);
          if (typeof freeGiftMsg === 'function') freeGiftMsg(cart);
          // PZ-redesign header reconcile: freeShippingMsg's _applyFreeShippingMsg
          // returns early for non-empty carts because the legacy #free_shipment
          // element doesn't exist — so cart_count_inner and pz-header__status
          // would never get updated on page load / drawer open / bfcache restore.
          // This call patches that gap with idempotent updates (no DOM write if
          // value already matches → no visible flash when already correct).
          this._pzReconcileHeader(cart);
          return cart;
      }).catch(() => {});
  }
  _pzReconcileHeader(cart, authoritative) {
      // P3 regression revert: apply the header write SYNCHRONOUSLY, like live (146987417709).
      // The Phase 2 scheduler split (a short trailing timer that deferred the apply into its
      // own delayed frame) made every cart mutation ping-pong the header
      // (correct→intermediate→correct), as successive reconcile passes each read a different
      // cart snapshot. Live writes inline, so the browser paint-coalesces the passes within
      // one frame and only the final value ever shows. The optimistic write in cart.js
      // (_b1ApplyOptimistic) remains the on-click value; this confirms it idempotently.
      if (!cart || typeof cart.item_count !== 'number') return;
      // P3 order-safe guard. A user qty/remove mutation paints optimistically
      // (cart.js _b1ApplyOptimistic) ~250ms BEFORE its /cart/change.js commit. In that
      // window a SPECULATIVE /cart.js read (refreshCartMessages on drawer-open, or
      // onCartDrawerUpdate's getCart) returns the PRE-commit server cart and would stomp the
      // correct optimistic value — then the authoritative commit reconcile fixes it: a
      // visible bounce. Each mutation bumps window._pzMutEpoch (cart.js updateQuantity); the
      // authoritative commit-response reconcile (authoritative===true) settles it. While a
      // mutation is unsettled, a speculative write is dropped — the message stays fully
      // dynamic, only the mid-flight stale frame is suppressed. Decrement-safe (it's
      // time-ordered, not magnitude-ordered) and freeze-proof (cart.js settles on a 4s
      // safety timer and on commit error).
      if (authoritative) {
          window._pzSettledEpoch = window._pzMutEpoch || 0;
      } else if ((window._pzMutEpoch || 0) > (window._pzSettledEpoch || 0)) {
          return;
      }
      // Sequence-guard: bump on every call. Late-arriving stale fetches drop out.
      if (typeof window._pzHeaderSeq !== 'number') window._pzHeaderSeq = 0;
      const mySeq = ++window._pzHeaderSeq;

      // CART (N) header count
      const countInner = document.getElementById('cart_count_inner');
      if (countInner) {
          countInner.dataset.pzSeq = String(mySeq);
          const newText = String(cart.item_count);
          if (countInner.textContent !== newText) countInner.textContent = newText;
      }

      // Free-shipping status text + bar fill
      const statusEl = document.querySelector('.pz-header__status');
      const barZone = document.querySelector('.pz-bar-zone');
      // P1.6 empty-cart fix: source the threshold from the STABLE header attr (.pz-header__status survives an emptied cart) before .pz-bar-zone (inside the AJAX items region — null on empty cart). Previously threshold came only from .pz-bar-zone → 0 on empty → block skipped → header stuck at "You've earned free shipping!". With a real threshold, total_price 0 → "Add {full} more" = the server's empty render. Reaches every path because onCartDrawerUpdate (the funnel) already calls this.
      const threshold = (statusEl && statusEl.dataset.shippingThresholdCents)
          ? parseInt(statusEl.dataset.shippingThresholdCents, 10)
          : (barZone ? parseInt(barZone.dataset.shippingThresholdCents || '0', 10) : 0);
      if (threshold > 0) {
          if (statusEl) {
              statusEl.dataset.pzSeq = String(mySeq);
              let newMsg;
              if (cart.total_price >= threshold) {
                  newMsg = "You've earned free shipping!";
              } else {
                  newMsg = 'Add ' + this._pzFormatMoney(threshold - cart.total_price, cart.currency) + ' more for free shipping';
              }
              if (statusEl.textContent.trim() !== newMsg.trim()) {
                  statusEl.textContent = newMsg;
              }
          }
          const fill = barZone ? barZone.querySelector('.progress-fill') : null; // guard — barZone is null on an emptied cart
          if (fill) {
              const pct = Math.min(100, Math.max(0, (cart.total_price / threshold) * 100));
              const newWidth = pct + '%';
              if (fill.style.width !== newWidth) fill.style.width = newWidth;
          }
      }

      // Empty-state visibility (the .pz-empty-cart block ships display:flex but
      // visibility:hidden+opacity:0 by default — needs explicit show on empty cart,
      // hide otherwise). This logic previously lived in cart-drawer.liquid's
      // updateHeader() which we no-op'd for the single-source fix; relocated here.
      const emptyEl = document.querySelector('.pz-empty-cart');
      if (emptyEl) {
          if (cart.item_count === 0) {
              if (emptyEl.style.visibility !== 'visible') emptyEl.style.visibility = 'visible';
              if (emptyEl.style.opacity !== '1') emptyEl.style.opacity = '1';
          } else {
              if (emptyEl.style.visibility !== 'hidden') emptyEl.style.visibility = 'hidden';
              if (emptyEl.style.opacity !== '0') emptyEl.style.opacity = '0';
          }
      }
  }
  _pzFormatMoney(cents, currencyCode) {
      // Prefer Shopify's formatMoney when available (preserves merchant's exact format).
      if (typeof formatMoney === 'function' && window.MinimogSettings && window.MinimogSettings.money_format) {
          return formatMoney(cents, window.MinimogSettings.money_format);
      }
      // Fallback: synthesize from currency code so the user never sees a money string
      // missing its currency symbol while theme-global.js is still lazy-loading.
      const sym = {
          GBP: '£', EUR: '€', USD: '$', CAD: 'CA$', AUD: 'A$', JPY: '¥'
      }[currencyCode] || '';
      return sym + (cents / 100).toFixed(2);
  }
  setHeaderCartIconAccessibility() {
      document.querySelectorAll(".m-cart-icon-bubble").forEach((t=>{
          t.setAttribute("role", "button"),
          t.setAttribute("aria-haspopup", "dialog"),
          t.addEventListener("click", (e=>{
              MinimogSettings.enable_cart_drawer && (e.preventDefault(),
              this.open(t))
          }
          ))
      }
      ))
  }
  
   
  open(t) {
      // P0.5: single fetch + fan-out (was 2-3 separate /cart.js fetches per open).
      this.refreshCartMessages();

      t && this.setActiveElement(t),
      this.classList.add("m-cart-drawer--active"),
      
        
      requestAnimationFrame((()=>{
          this.style.setProperty("--m-bg-opacity", "0.5"),
          this.cartDrawerInner.style.setProperty("--translate-x", "0")
      }
      )),
      $('#chat-button').css('display','none');
      document.documentElement.style.overflow = 'hidden';
      window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer)

      // spinner stop for sticky atc bottom
      const stickyBtn = document.querySelector(".sticky_atc_btn_bottom");
      if (!stickyBtn) return;
      if(stickyBtn){
        const spinner = stickyBtn.querySelector(".m-spinner-icon");
        const text = stickyBtn.querySelector(".m-add-to-cart--text");
        const svgicon = spinner.querySelector("svg");
        spinner.style.display = "none";
        text.style.display = "inline-block";
        svgicon.style.display = "none";
      }
  }
  close() {
      this.style.setProperty("--m-bg-opacity", "0"),
      this.cartDrawerInner.style.setProperty("--translate-x", "100%"),
      setTimeout((()=>{
          this.classList.remove("m-cart-drawer--active");
          $('#chat-button').css('display','block');
          document.documentElement.style.overflow = '';
      }
      ), 300)
  }
  renderContents(t) {
      this.classList.contains("m-cart--empty") && this.classList.remove("m-cart--empty"),
      this.productId = t.id,
      this.getSectionsToRender().forEach((e=>{
          (e.selector ? document.querySelector(e.selector) : document.getElementById(e.id)).innerHTML = this.getSectionInnerHTML(t.sections[e.id], e.selector)
      }
      )),
      setTimeout((()=>{
          this.open(),
          window.FoxKitV2 && window.FoxKitV2.Modules.InCart && window.FoxKitV2.Modules.InCart.getCart()
      }
      ))
  }
  updateCartCount(t) {
      document.querySelectorAll(".m-cart-count-bubble").forEach((e=>{
          t > 0 ? (e.textContent = t,
          e.classList.remove("hidden")) : e.classList.add("hidden")
      }
      ))
  }
  getCart() {
      return fetchJSON(this.rootUrl + "cart.json")
  }
  onCartDrawerUpdate(t=!0) {

      fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`).then((t=>t.text())).then((e=>{
          this.getSectionsToRender().forEach((r=>{
              if ("cart-items" === r.block) {
                  (r.selector ? document.querySelector(r.selector) : document.getElementById(r.id)).innerHTML = this.getSectionInnerHTML(e, r.selector),
                  window.FoxKitV2 && window.FoxKitV2.Modules.InCart && window.FoxKitV2.Modules.InCart.getCart()
              } else if (t) {
                  (r.selector ? document.querySelector(r.selector) : document.getElementById(r.id)).innerHTML = this.getSectionInnerHTML(e, r.selector)
              }
          }
          ))
      }
      )).catch((t=>{}
      )),
      // P0.5 + Bug-2 fix: one /cart.js fetch drives count + empty toggle + all post-render hooks
      // (free-shipping msg, free-gift msg, freeGiftAddAutomatic cascade for orphan cleanup).
      // Single fetch, fresh cart, fires once per state change.
      this.getCart().then((cart=>{
          this.classList.toggle("m-cart--empty", 0 === cart.item_count),
          this.updateCartCount(cart.item_count);
          freeShippingMsg(cart);
          if (typeof freeGiftMsg === 'function') freeGiftMsg(cart);
          if (typeof freeGiftAddAutomatic === 'function') freeGiftAddAutomatic(cart);
          if (typeof cleanupOrphanedDiscoveryItems === 'function') cleanupOrphanedDiscoveryItems(cart);
          pzClampLockedQty(cart);
          // R3 fix: onCartDrawerUpdate is the post-mutation refresh path used by the LP's
          // cleanupOrphanedDiscoveryItems (lp-product-form.liquid:1361), c_remove
          // (cart.js:708), gift-wrapping save (gift-wrapping.js), and the bundle-remove
          // handler (theme-global.js). Without this call, those paths would refresh
          // the items section but never toggle .pz-empty-cart visibility or rewrite
          // #cart_count_inner / .pz-header__status. LP-side symptom: emptying the cart
          // leaves a blank drawer (empty-state CTAs hidden by default CSS).
          this._pzReconcileHeader(cart);
      }
      ))
  }
  getSectionInnerHTML(t, e=".shopify-section") {
   
      return (new DOMParser).parseFromString(t, "text/html").querySelector(e).innerHTML
  }
  getSectionsToRender() {
      return [{
          id: "cart-drawer",
          selector: "[data-minimog-cart-items]",
          block: "cart-items"
      }, {
          id: "cart-drawer",
          selector: "[data-minimog-cart-discounts]",
          block: "cart-footer"
      }, {
          id: "cart-drawer",
          selector: "[data-cart-subtotal]",
          block: "cart-footer"
      }, {
          id: "cart-drawer",
          // STEP 2: checkout-button label (CHECKOUT | price + strike) lives outside
          // [data-cart-subtotal] — swap it too so the strike stays cart-true.
          selector: "[data-pz-checkout-label]",
          block: "cart-footer"
      }, {
          id: "cart-drawer",
          // STEP 3: bronzer bar zone between scroll body and footer — server-side
          // state (hero pattern) so render/no-render tracks the cart exactly.
          selector: "[data-pz-bronzer-bar]",
          block: "cart-footer"
      }, {
          id: "cart-drawer",
          selector: "[data-minimog-gift-wrapping]",
          block: "cart-footer"
      }]
  }
  getSectionDOM(t, e=".shopify-section") {
      return (new DOMParser).parseFromString(t, "text/html").querySelector(e)
  }
  setActiveElement(t) {
      this.activeElement = t
  }
}
customElements.define("m-cart-drawer", MCartDrawer);
class MCartDrawerItems extends MCartTemplate {
  getSectionsToRender() {
      return [{
          id: "MinimogCartDrawer",
          section: "cart-drawer",
          selector: "[data-minimog-cart-items]"
      }, {
          id: "MinimogCartDrawer",
          section: "cart-drawer",
          selector: "[data-minimog-cart-discounts]"
      }, {
          id: "MinimogCartDrawer",
          section: "cart-drawer",
          selector: "[data-cart-subtotal]"
      }, {
          id: "MinimogCartDrawer",
          section: "cart-drawer",
          // STEP 2: keep the checkout-button price + strike cart-true (see MCartDrawer list)
          selector: "[data-pz-checkout-label]"
      }, {
          id: "MinimogCartDrawer",
          section: "cart-drawer",
          // STEP 3: bronzer bar zone (see MCartDrawer list)
          selector: "[data-pz-bronzer-bar]"
      }, {
          id: "MinimogCartDrawer",
          section: "cart-drawer",
          selector: "[data-minimog-gift-wrapping]"
      }]
  }
}
customElements.define("m-cart-drawer-items", MCartDrawerItems);

// P0.5: accepts an optional cart object. If provided, skips the /cart.js fetch and the 1000ms
// settling delay (which existed to wait for an in-flight cart change to commit). Callers that
// already have a fresh cart from a sibling fetch can pass it in to avoid the duplicate roundtrip.
function freeShippingMsg(cart) {
  emptyFreeCartMsg(cart);

  function _applyFreeShippingMsg(cart) {
    specialofferScroller();
    cartCountUpdate(cart);
    if (cart.total_price > 0) {
      var element = document.getElementById("free_shipment");
      if(!element){
        return;
      }
      element.classList.remove("hidden");

      var upsellBlock = document.querySelector('.upsell_block');
      if (upsellBlock) upsellBlock.classList.remove('hidden');

      var priceCart = cart.total_price;
      var cartCountInner = document.getElementById("cart_count_inner");
      if (cartCountInner) cartCountInner.textContent = cart.item_count;

      const link = document.querySelector('#valFreeShip');
      var minOrderValue = link.getAttribute('data-freeshipment');
      var freeShipmsg = link.getAttribute('data-freeshippingmsg');
      var preShipmsg = link.getAttribute('data-prepricetxt');
      var postShipmsg = link.getAttribute('data-postpricetxt');
      // console.log(minOrderValue);

      if (priceCart >= minOrderValue) {
        link.innerHTML = `<div class='free_ship_msg'>${freeShipmsg}</div>`;
        // var giftProgressSection = document.querySelector('.gift-progress-section');
        // if (giftProgressSection) giftProgressSection.classList.remove('setPositionShiiping');
      } else {
        // var giftProgressSection = document.querySelector('.gift-progress-section');
        // if (giftProgressSection) giftProgressSection.classList.add('setPositionShiiping');

        let percent = (priceCart / minOrderValue) * 100;
        let left = formatMoney((minOrderValue - priceCart), MinimogSettings.money_format);
        link.innerHTML = `<div class='free_ship_msg'>${preShipmsg} <span>${left}</span> ${postShipmsg}</div>`;
      }

      var progressBar = document.querySelector("progress");
      if (progressBar) progressBar.setAttribute("value", priceCart);

    } else {
      var upsellBlock = document.querySelector('.upsell_block');
      if (upsellBlock) upsellBlock.classList.add('hidden');

      var cartCountInner = document.getElementById("cart_count_inner");
      if (cartCountInner) cartCountInner.textContent = 0;

      var cartBubbleSpan = document.querySelector(".m-header__right .m-cart-icon-bubble span");
      if (cartBubbleSpan) {
        cartBubbleSpan.textContent = 0;
        cartBubbleSpan.classList.remove('m:hidden');
      }

      var element = document.getElementById("free_shipment");
      if (element) element.classList.add("hidden");
    }
  }

  if (cart) {
    _applyFreeShippingMsg(cart);
  } else {
    setTimeout(function() {
      fetch('/cart.js').then(resp => resp.json()).then(_applyFreeShippingMsg);
    }, 1000);
  }
  // freeShippingMsgUpgrade();
}

function specialofferScroller(){
  const slider = document.querySelector('.special_offer_slider');
  let isDown = false;
  let startX;
  let scrollLeft;
  if(slider){
    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mousemove', (e) => {
      if(!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1; //scroll-fast
      slider.scrollLeft = scrollLeft - walk;
      // console.log(walk);
    });
  }
}

function cartCountUpdate(cart){
  var cart_count = cart.item_count;
  // console.log(cart_count);
  if(cart_count == 0){
    $('.cart_empty_btn').removeClass('hidden');
    $('.cart_items_btn').addClass('hidden');
  }else{
    $('.cart_empty_btn').addClass('hidden');
    $('.cart_items_btn').removeClass('hidden');
  }
}

// P0.5: accepts an optional cart object. If provided, no /cart.js fetch.
function emptyFreeCartMsg(cart) {

  function _applyEmptyFreeCartMsg(cart) {
    let customerLogin = $(`.customer_check`).attr(`data-customers-order`);
    if (customerLogin && customerLogin == 0 && customerLogin != null){
      if(cart.total_price == 0 && cart.item_count == 0){
          $('.customer_check').css('display','block');
          $('.customer_check').removeClass('hidden');
      }else{
        // $('.customer_check').css('display','block');
        $('.customer_check').addClass('hidden');
      }
    }else{
      // $('.customer_check').css('display','block');
      $('.customer_check').addClass('hidden');
    }
  }

  if (cart) {
    _applyEmptyFreeCartMsg(cart);
  } else {
    setTimeout(function(){
      let customerLogin = $(`.customer_check`).attr(`data-customers-order`);
      if (customerLogin && customerLogin == 0 && customerLogin != null){
        fetch('/cart.js').then((resp) => resp.json()).then(_applyEmptyFreeCartMsg);
      }else{
        $('.customer_check').addClass('hidden');
      }
    },100);
  }
}
// P0.5: accepts an optional cart object. If provided, no /cart.js fetch and no settling delay.
function freeGiftMsg(cart){
  function _applyFreeGiftMsg(cart){
    // console.log(cart.total_price);

    if(cart.total_price > 0 || cart.item_count > 0){

      var hasFreeGift = false;
      
        const link = document.querySelector('#valFreeGift');
        const freeGiftLabel = document.querySelector('#freeGiftLabel');
        // P1.6: guard — #valFreeGift/#freeGiftLabel are injected via the ?section_id=cart-drawer re-render and are absent on initial paint, so the bare getAttribute below threw on load → aborted freeGiftMsg before _pzReconcileHeader ran → header frozen at the empty-cart value. Bail when absent (no free-gift UI to update; the rest of this fn is the gift-only if-branch + a mutually-exclusive empty-cart else, nothing after). Currency-agnostic.
        if (!link || !freeGiftLabel) return;


        var minOrderValueGift = link.getAttribute('data-freegift');
        var freeshipmentLimit = link.getAttribute('data-shiplimit');
        var giftTit = freeGiftLabel.getAttribute('data-freeTit');
        var giftPrc = freeGiftLabel.getAttribute('data-freePrc');
        var giftProductId = freeGiftLabel.getAttribute('data-freegiftId');
        var giftProductKey = freeGiftLabel.getAttribute('data-freegiftKey');

        
        
      cart.items.forEach(function(product, index) { 
        if(giftProductId == product.product_id && typeof(product.properties['_masterProduct'] == 'undefined')){
    
            if(cart.item_count == 1 && giftProductId == product.product_id){
              // remove free gift 
              c_remove(product.key);
                
              freeGiftMsg();
              
              
            }else if(cart.item_count > 1 && giftProductId == product.product_id && cart.total_price < minOrderValueGift){
          
                c_remove(product.key);
              
              
            }
            else{
              
                hasFreeGift = true;
              
                var hideElement = document.getElementById("free_gift");
                hideElement.classList.add("hidden");
            
                var hideBoxgift = document.getElementById("giftBox");
                hideBoxgift.classList.add("hidden");
                var priceCart = cart.total_price;
              var customTxt = "";
                // customMsg(customTxt, priceCart);
              
              // only one gift added CJ
              if(product.quantity > 1 && giftProductId == product.product_id){
                  console.log(product.quantity);
                onlyOneGift(product.id, product.quantity);
                }
              
            }
          
        }
      });

      if(hasFreeGift == false && cart.total_price > 0)
      {
        var element = document.getElementById("free_gift");
        element.classList.remove("hidden");
    
        var boxgift = document.getElementById("giftBox");
        boxgift.classList.remove("hidden");

      
        $('.upsell_block').removeClass('hidden');
        var priceCart = cart.total_price;
        $("#cart_count_inner").text(cart.item_count);

  
    
        // console.log(minOrderValueGift+'herehere');
        
          if (priceCart >= minOrderValueGift){
            
            if(priceCart >= freeshipmentLimit){
                $('#free_gift .shipping_icon').addClass('target_com');
            }else{
                $('#free_gift .shipping_icon').removeClass('target_com');
            }
            $('.gift-progress-section').addClass('setPosition');
            document.getElementById("valFreeGift").innerHTML = "<div class='free_gift_msg'> You've unlocked your <span class='gift_title'>Free Gift</span>.</div>";
            document.getElementById("freeGiftLabel").innerHTML = "<p class='free_gift_remain'> You've unlocked your <span class='gift_title'>Free Gift</span>.</p>";
            document.querySelector(".free_gift_wrp .m-add-to-cart.m-button").disabled = false;
            document.querySelector(".free_gift_wrp .m-add-to-cart.m-button").classList.add('activate');
            document.querySelector(".free_gift_wrp .m-add-to-cart.m-button").classList.remove('deactivate');
            var customTxt = "Add another and get <span>Free Shipping</span>";
            // customMsg(customTxt, priceCart);
            $('#free_gift .gift_icon').addClass('target_com');
          
          }
          else{
            $('#free_gift .gift_icon').removeClass('target_com');
            if(priceCart >= freeshipmentLimit){
                $('#free_gift .shipping_icon').addClass('target_com');
                $('#free_gift .shipping-savings-message').removeClass('visibilityCheck');
                $('.gift-progress-section').addClass('setPosition');
            
                  // console.log('alert');
                  let percent = priceCart / minOrderValueGift * 100;
                
                  let left = formatMoney((minOrderValueGift - priceCart), MinimogSettings.money_format);
              
                  document.getElementById("valFreeGift").innerHTML = "<div class='free_gift_msg'>ADD <span>"+ left +"</span> to unlock your FREE GIFT</div>";
                  document.getElementById("freeGiftLabel").innerHTML = "<p class='free_gift_remain'>Spend another <span>"+ left +"</span> to get this gift worth <span class='gift_price'>"+ giftPrc +"</span>.</p>";
                  var customTxt = "Add another and get <span>Free Shipping & Gift</span>";
                  // customMsg(customTxt, priceCart);
                  document.querySelector(".free_gift_wrp .m-add-to-cart.m-button").disabled = true;
                  document.querySelector(".free_gift_wrp .m-add-to-cart.m-button").classList.add('deactivate');
                  document.querySelector(".free_gift_wrp .m-add-to-cart.m-button").classList.remove('activate');

              
            }else{
                $('#free_gift .shipping_icon').removeClass('target_com');
                $('#free_gift .shipping-savings-message').addClass('visibilityCheck');
                $('.gift-progress-section').removeClass('setPosition');
              
            }
            
          }
          var gift = document.querySelector(".progress_gift");
            // Set the value of progress element

        // cj real progress value 
            // gift.setAttribute("value", priceCart);
            //  updateProgressBar(priceCart, minOrderValueGift);
      }
      }else{
        $("#cart_count_inner").text(0);
      $(".m-header__right .m-cart-icon-bubble span").text(0);
      
      $(".m-header__right .m-cart-icon-bubble span").removeClass('m:hidden');
        $('.upsell_block').addClass('hidden');
          var element = document.getElementById("free_gift");
          element.classList.add("hidden");

        var boxgift = document.getElementById("giftBox");
        boxgift.classList.add("hidden");
      }
  }

  if (cart) {
    _applyFreeGiftMsg(cart);
  } else {
    setTimeout(function(){
      fetch('/cart.js').then((resp) => resp.json()).then(_applyFreeGiftMsg);
    },1000);
  }
}



// Bug-2 follow-up: set-linked orphan cleanup.
// Removes items that only belong in cart while the Discovery Set bundle is present —
// the discounted Discovery brush (DOUBLEBRUSH at 50% off) and the DISCOVERYGWP free gift.
// Without this, removing the set leaves the brush at €13.48 (50% discount carries to
// checkout — revenue leak) and the gift at €0.
// Single-fetch discipline: callers pass the fresh cart from /cart.js. Falls back to a
// fetch only when called without a cart (back-compat).
const DISCOVERY_BRUSH_PRODUCT_ID = 7865418121325;
const DISCOVERY_BRUSH_VARIANT_ID = 43612451995757;
// STEP 3b (bronzer bar): the offer bronzer is pair-conditional — it needs
// (set + set-brush) OR (single blush + single brush) intact. Set-offer
// bronzer product ONLY (hidden duplicate velvet-bronzer-set-offer); the PDP
// bronzer (3950068531309) and unmarked lines are invisible to the sweep.
const SINGLE_BRUSH_VARIANT_ID = 41968089989229;
const PZ_MAIN_BLUSH_PRODUCT_ID = 3950081540205;
const PZ_BRONZER_PRODUCT_ID = 15356509913197;
// What the LAST scan marked, by kind — read by the executor to compose the
// removal note (spec: no silent dependent removals; one combined toast).
let _pzOrphanKindsLast = { palette: false, bronzer: false };
let _discoveryCleanupRunning = false;
let _discoveryCleanupFails = 0;   // circuit-breaker: consecutive REAL failures (422 with orphans persisting)
let _discoveryCleanupLastAt = 0;  // burst tracking — reset the fail count after a quiet period

// Scan a cart snapshot for orphaned-discovery line keys. Returns a {key:0,...} map (possibly
// empty when nothing to remove / bundle still present), or null if the cart is indeterminate.
function _pzFindDiscoveryOrphans(cart) {
  if (!cart || !Array.isArray(cart.items)) return null;
  const updates = {};
  _pzOrphanKindsLast = { palette: false, bronzer: false };
  const bundlePresent = cart.items.some(item => item.properties && item.properties._masterProduct);
  // Qualifier = the SPECIFIC brush VARIANT this LP's gift is tied to (43612451995757), NOT the
  // broader product id — a different variant of the same product must not qualify.
  const brushVariantPresent = cart.items.some(item => item.variant_id === DISCOVERY_BRUSH_VARIANT_ID);
  // STEP 3b: brush/palette rules unchanged in semantics, but no longer an early
  // `return {}` when the bundle is present — the bronzer rules below must run on
  // EVERY scan (e.g. set intact but brush binned → discovery pair broken).
  if (!bundlePresent) {
    // The qualifying brush variant itself — orphan when its parent Discovery Set bundle is gone.
    cart.items.forEach(item => { if (item.variant_id === DISCOVERY_BRUSH_VARIANT_ID) updates[item.key] = 0; });
    const brushRemovedThisSweep = Object.keys(updates).length > 0;
    // The gift palette — an app-managed `_Gifted` line (matched by KEY PRESENCE; the value carries a
    // rotating campaign date) is orphaned when its qualifying brush VARIANT is absent (flow A: brush
    // already removed) OR the brush is being removed in THIS same sweep (flow B: Set-removal orphans
    // brush + gift together → one combined {brush:0,palette:0} POST, no two-pass 422-retry bounce).
    // Standalone palette (no `_Gifted`) untouched; a mid-add gift (brush present and NOT an orphan)
    // untouched. Keyed on cart membership, not price.
    cart.items.forEach(item => {
      if (item.properties && ('_Gifted' in item.properties) && (!brushVariantPresent || brushRemovedThisSweep)) {
        updates[item.key] = 0;
        _pzOrphanKindsLast.palette = true;
      }
    });
  }
  // STEP 3b: offer bronzer (`_pzSetOffer` on the set-offer product) survives only
  // while a complete qualifying pair is intact. Discovery pair = bundle + set-brush
  // (a set-brush being swept above means bundlePresent is false → pair already dead).
  // Single pair = a non-bundle main-blush line + the single brush. Removing the
  // bronzer itself never cascades anywhere — it is a qualifier for nothing.
  const singleBlushPresent = cart.items.some(item => item.product_id === PZ_MAIN_BLUSH_PRODUCT_ID && !(item.properties && item.properties._masterProduct));
  const singleBrushPresent = cart.items.some(item => item.variant_id === SINGLE_BRUSH_VARIANT_ID);
  // QA issue 2 (21 Jul): discovery pair accepts EITHER offer brush variant — the
  // brush PDP adds the single record (41968089989229) and that qualifies a set
  // cart too. LOCKSTEP with the bar's Liquid gate. Pricing is the VelvetBronz
  // amount-off discount (50%, the 3 set-offer product variants only, no minimum)
  // — it has NO cart condition, so gate + this sweep are the ONLY enforcement.
  // Single pair deliberately unchanged (set-brush without a bundle is removed
  // by the legacy rules above — gating single on it would churn).
  const discoveryPairOk = bundlePresent && (brushVariantPresent || singleBrushPresent);
  const singlePairOk = singleBlushPresent && singleBrushPresent;
  if (!discoveryPairOk && !singlePairOk) {
    cart.items.forEach(item => {
      if (item.properties && ('_pzSetOffer' in item.properties) && item.product_id === PZ_BRONZER_PRODUCT_ID) {
        updates[item.key] = 0;
        _pzOrphanKindsLast.bronzer = true;
      }
    });
  }
  return updates;
}

// STEP 3b: dependent removals must never be silent — one combined note per sweep
// (sequential kinds in the same POST share a single toast).
function _pzOrphanNote(kinds) {
  if (!kinds) return '';
  if (kinds.bronzer && kinds.palette) return 'Bronzer & free palette removed — set offer no longer applies';
  if (kinds.bronzer) return 'Bronzer removed — set offer no longer applies';
  if (kinds.palette) return 'Free palette removed — brush offer no longer applies';
  return '';
}

// Freeze fix (22 Jul): visual-only undo of the sweep's pre-POST veils when the
// removal did NOT happen (persistent 422 / network error). Unveils each veiled
// row and strips its key from a keys-only watch so the tick can't instantly
// re-veil; cascade watches (tid/gifted flows) are left untouched. No cart
// mutation here — the POST payload and "line we own" guard are unaffected.
function _pzCleanupUnveil(updates) {
  try {
    if (!updates || typeof _pzSweepUnveil !== 'function') return;
    Object.keys(updates).forEach(function (k) {
      const row = document.querySelector('m-cart-drawer-items [data-cart-item][data-item-key="' + k + '"]');
      if (row) _pzSweepUnveil(row);
    });
    if (_pzSweepWatch && _pzSweepWatch.keys && !_pzSweepWatch.cascade && !_pzSweepWatch.tid) {
      _pzSweepWatch.keys = _pzSweepWatch.keys.filter(function (k) { return !(k in updates); });
      if (_pzSweepWatch.keys.length === 0) {
        _pzSweepWatch = null;
        _pzSweepLockBins(false);
      }
    }
  } catch (_) {}
}

// P1.6 durable bundle-422 fix (built on the two-guard floor — NO shared flag, the confirmed accelerant):
//  • Re-read /cart.js FRESH immediately before POST → build {key:0} from CURRENT line keys (stale
//    keys captured earlier are what 422'd). If orphans already gone in the fresh read → skip the
//    POST (that's success, not a no-op error).
//  • Treat a 422 IDEMPOTENTLY: re-read /cart.js; if the orphans are gone (the other cleanup already
//    removed them) treat it as success — no error, and no onCartDrawerUpdate re-render (so it can't
//    re-feed the observer). Only count a failure if orphans PERSIST after the 422.
//  • Circuit-breaker: after 3 real failures within a burst, stop re-trying so a doomed POST can
//    never loop the MutationObserver again (insurance against Phase-3 timing churn). The (ignored)
//    cart arg is intentional — callers may pass a cart, but we always re-read for correctness.
function cleanupOrphanedDiscoveryItems() {
  if (_discoveryCleanupRunning) return;
  const now = Date.now();
  if (now - _discoveryCleanupLastAt > 8000) _discoveryCleanupFails = 0; // new burst → reset the cap
  _discoveryCleanupLastAt = now;
  if (_discoveryCleanupFails >= 3) return;                              // circuit-breaker tripped this burst
  _discoveryCleanupRunning = true;
  const release = () => { setTimeout(() => { _discoveryCleanupRunning = false; }, 600); };
  fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json()).then(fresh => {
    const updates = _pzFindDiscoveryOrphans(fresh);
    // STEP 3b: capture this scan's kinds NOW — a later scan (422 re-check) resets them.
    const kinds = { palette: _pzOrphanKindsLast.palette, bronzer: _pzOrphanKindsLast.bronzer };
    if (!updates || Object.keys(updates).length === 0) {
      _discoveryCleanupFails = 0; // nothing to remove (bundle present / already clean) → success
      release();
      return;
    }
    // QA 21 Jul: dependency-sweep victims must not blink out silently — veil
    // them (same ceremony as user removals) and register their keys so swaps
    // keep them veiled until the converge render drops them; toast follows.
    try {
      if (typeof _pzSweepVeil === 'function') {
        Object.keys(updates).forEach(function (k) {
          const row = document.querySelector('m-cart-drawer-items [data-cart-item][data-item-key="' + k + '"]');
          if (row) _pzSweepVeil(row);
        });
        if (_pzSweepWatch) {
          _pzSweepWatch.keys = (_pzSweepWatch.keys || []).concat(Object.keys(updates));
          _pzSweepWatch.until = Math.max(_pzSweepWatch.until, Date.now() + 8000);
        } else {
          _pzSweepWatch = { keys: Object.keys(updates), until: Date.now() + 8000 };
        }
      }
    } catch (_) {}
    fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'xmlhttprequest' },
      body: JSON.stringify({ updates })
    }).then(resp => {
      if (resp.ok) {
        _discoveryCleanupFails = 0;
        return resp.json().then(() => {
          // STEP 3b: never silent — one combined note for everything this sweep removed.
          const note = _pzOrphanNote(kinds);
          if (note) { try { if (typeof _pzB2Toast === 'function') _pzB2Toast(note); } catch(_) {} }
          if (window.cartDrawer && typeof window.cartDrawer.onCartDrawerUpdate === 'function') {
            try { window.cartDrawer.onCartDrawerUpdate(); } catch(_) {}
          }
        });
      }
      // Non-OK (422): idempotent check — did the other cleanup already remove the orphans?
      return fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json()).then(after => {
        const still = _pzFindDiscoveryOrphans(after);
        if (!still || Object.keys(still).length === 0) {
          _discoveryCleanupFails = 0; // orphans gone → idempotent success, no re-render (no observer churn)
          // STEP 3b: the removal still HAPPENED (the other cleaner won the race) — note it.
          const note = _pzOrphanNote(kinds);
          if (note) { try { if (typeof _pzB2Toast === 'function') _pzB2Toast(note); } catch(_) {} }
        } else {
          _discoveryCleanupFails++;   // genuine failure: orphans persist
          _pzCleanupUnveil(updates);  // freeze fix: no stuck REMOVING… on failed removals
        }
      });
    }).catch(() => { _pzCleanupUnveil(updates); }).finally(release);
  }).catch(release);
}
// Expose to cart.js (loads first) so updateQuantity can call it from its .then.
window.cleanupOrphanedDiscoveryItems = cleanupOrphanedDiscoveryItems;

// PZ qty-lock reconcile (Push 2.1): the discounted brush SKUs are once-per-offer.
// The stepper is gone from the drawer template and cart.js clamps updateQuantity,
// but a /cart/add.js of the same variant MERGES quantities server-side (e.g. the
// PDP brush tick while a brush is already in the cart) — no updateQuantity path
// sees that. This runs in the onCartDrawerUpdate funnel: if a locked line exceeds
// qty 1, set it back to exactly 1. Loop-safe by construction: fires only when
// qty > 1, converges to a state where it never fires; run-lock + one line per
// pass mirrors the freeGiftAddAutomatic discipline.
// ============================================================
// PZ B2 — Feature 2, SINGLE pattern (design 7c): EVERY drawer removal
// gets the sweep. Bin tap → white veil + "REMOVING…" + 1.6s black
// progress sweep over the affected row(s), ALL bins disabled (re-clicks
// impossible by design) → the delete fires IMMEDIATELY in the background
// (key-based sequential queue; checkout-safe — no deferred deletion a
// fast CHECKOUT tap could outrun) → affected rows collapse together
// (350ms glide) → the converge re-render settles totals/Saved/shipping
// and runs every existing hook (freeShippingMsg, freeGiftAddAutomatic,
// orphan cleanup, qty clamp, header reconcile). Failure lifts the veil
// with "Couldn't remove — try again" in the status toast.
// Cascades sweep all affected rows: set brush → + palette (handled in
// pzB2Remove); bundle bin → set + brush + palette (veil layered over the
// untouched theme-global machinery, below). The earlier optimistic
// instant-collapse + UNDO variant was retired by request — one pattern.
// ============================================================
let _pzB2Chain = Promise.resolve();
let _pzB2Pending = 0;
function _pzB2Enqueue(task) {
  _pzB2Pending++;
  _pzB2Chain = _pzB2Chain.then(task).catch(function () {}).then(function () {
    _pzB2Pending--;
    if (_pzB2Pending === 0) _pzB2Converge();
  });
}
function _pzB2Converge() {
  // Never let the authoritative re-render land mid-collapse: hold it until
  // ≥420ms after the last collapse started (the glide is 350ms). If new work
  // was queued while we waited (e.g. UNDO's re-add), skip — the queue will
  // converge again when it drains.
  const since = Date.now() - (window._pzB2LastCollapseAt || 0);
  setTimeout(function () {
    if (_pzB2Pending > 0) return;
    window._pzSettledEpoch = window._pzMutEpoch || 0; // authoritative settle
    if (window.cartDrawer && typeof window.cartDrawer.onCartDrawerUpdate === 'function') {
      try { window.cartDrawer.onCartDrawerUpdate(); } catch (_) {}
    }
  }, Math.max(0, 420 - since));
}

function _pzB2Collapse(el) {
  // Explicit pixel height (not max-height): the tween runs over the exact
  // row height, so 350ms reads as 350ms. Start height is committed first,
  // then the end state is applied behind a DOUBLE requestAnimationFrame —
  // a forced reflow alone is not enough on Safari, which can batch both
  // writes into one style recalc and jump straight to the end (the "hard
  // swipe" snap this replaces).
  const h = el.scrollHeight;
  el.dataset.pzB2Height = String(h);
  el.style.overflow = 'hidden';
  el.style.height = h + 'px';
  el.style.maxHeight = 'none';
  el.style.minHeight = '0px'; // theme rules can floor the row — 0 must mean 0
  el.style.pointerEvents = 'none';
  void el.offsetHeight;
  window._pzB2LastCollapseAt = Date.now();
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      el.style.transition = 'height .35s ease, opacity .35s ease, padding .35s ease, margin .35s ease';
      el.style.height = '0px';
      el.style.opacity = '0';
      // setProperty(...,'important'): a theme !important padding rule beats a
      // plain inline write, and with border-box the row can't shrink below its
      // padding — this was the 16px residual sliver in the tween measurements.
      el.style.setProperty('padding-top', '0px', 'important');
      el.style.setProperty('padding-bottom', '0px', 'important');
      el.style.setProperty('margin-top', '0px', 'important');
      el.style.setProperty('margin-bottom', '0px', 'important');
    });
  });
}
// Status toast — failure feedback only (UNDO retired with the optimistic flow).
let _pzB2ToastTimer = null;
function _pzB2Toast(msg) {
  const toast = document.querySelector('.pz-undo-toast');
  if (!toast) return;
  const textEl = toast.querySelector('.pz-undo-toast__text');
  if (textEl) textEl.textContent = msg;
  toast.hidden = false;
  requestAnimationFrame(function () { toast.classList.add('pz-undo-toast--visible'); });
  clearTimeout(_pzB2ToastTimer);
  _pzB2ToastTimer = setTimeout(function () {
    toast.classList.remove('pz-undo-toast--visible');
    setTimeout(function () { toast.hidden = true; }, 250);
  }, 4000);
}

// ============================================================
// PZ Pattern 2 (design 7c): sweep overlay for CASCADE removals — one action
// that removes multiple rows. Cases wired here:
//   A. Set-brush bin (43612451995757) while a _Gifted palette line exists →
//      veil brush + palette rows, ONE combined /cart/update.js POST (the same
//      combined-keys design the orphan cleanup uses to avoid two-pass 422s),
//      ≥1.6s sweep, then both rows collapse together. No UNDO on sweeps.
//   B. Bundle bin (.remove_bundle_product) → the existing theme-global.js
//      handler + orphan cleanup run UNTOUCHED; a capture-phase listener only
//      LAYERS veils over the affected rows (set lines + set brush + _Gifted)
//      and keeps re-applying them across the cascade's re-renders until the
//      rows are gone or 6s passes. Bins are disabled for the duration.
// There is no clear-cart control in the drawer, so nothing to wire for it.
// ============================================================
function _pzAnnounce(text) {
  const live = document.querySelector('.pz-cart-live');
  if (!live) return;
  live.textContent = '';
  setTimeout(function () { live.textContent = text; }, 50);
}
function _pzSweepVeil(row) {
  if (!row || row.querySelector('.pz-sweep-veil')) return;
  row.classList.add('pz-sweeping');
  row.setAttribute('aria-busy', 'true');
  const veil = document.createElement('div');
  veil.className = 'pz-sweep-veil';
  veil.innerHTML = '<div class="pz-sweep-veil__label">REMOVING…</div>' +
                   '<div class="pz-sweep-veil__bar"><div class="pz-sweep-veil__fill"></div></div>';
  row.appendChild(veil);
}
function _pzSweepUnveil(row) {
  if (!row) return;
  row.classList.remove('pz-sweeping');
  row.removeAttribute('aria-busy');
  const veil = row.querySelector('.pz-sweep-veil');
  if (veil) veil.remove();
}
function _pzSweepLockBins(on) {
  const region = document.querySelector('m-cart-drawer-items');
  if (!region) return;
  region.classList.toggle('pz-sweep-lock', !!on);
  region.querySelectorAll('m-cart-remove-button, .remove_bundle_product').forEach(function (b) {
    if (on) b.setAttribute('aria-disabled', 'true');
    else b.removeAttribute('aria-disabled');
  });
}

// THE removal flow — one or many rows, always the same sweep ceremony.
function _pzSweepRemove(rows, updates, startMsg, endMsg) {
  rows = rows.filter(function (r) { return !!r; });
  if (!rows.length || !Object.keys(updates).length) return;
  rows.forEach(_pzSweepVeil);
  _pzSweepLockBins(true);
  _pzAnnounce(startMsg);
  // Register the removal keys under the sweep-watch so ANY swap during the
  // ceremony re-veils the fresh rows (merges with the brush-cascade watch).
  const watchKeys = Object.keys(updates);
  if (_pzSweepWatch) {
    _pzSweepWatch.keys = (_pzSweepWatch.keys || []).concat(watchKeys);
    _pzSweepWatch.until = Math.max(_pzSweepWatch.until, Date.now() + 8000);
  } else {
    _pzSweepWatch = { keys: watchKeys, until: Date.now() + 8000 };
  }
  const t0 = Date.now();
  _pzB2Enqueue(function () {
    return fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'xmlhttprequest' },
      body: JSON.stringify({ updates: updates })
    }).then(function (resp) {
      if (resp.ok) return true;
      // 422 idempotency (mirrors the orphan cleanup): if the keys are already
      // gone (an app raced us), that IS success.
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        const still = (cart.items || []).some(function (i) { return updates.hasOwnProperty(i.key); });
        if (still) throw new Error('remove failed');
        return true;
      });
    }).then(function () {
      // hold the veil until the 1.6s sweep has played out
      return new Promise(function (res) { setTimeout(res, Math.max(0, 1600 - (Date.now() - t0))); });
    }).then(function () {
      // Gifted rows under a sweep-watch aren't in this POST — they leave at
      // their own re-render (still veiled); collapsing them here would bounce
      // (collapse → re-render resurrects → cleanup removes).
      rows.forEach(function (r) {
        if (r.isConnected && !(r.dataset && r.dataset.pzGifted === '1' && _pzSweepWatch)) _pzB2Collapse(r);
      });
      _pzAnnounce(endMsg);
      return new Promise(function (res) { setTimeout(res, 380); }); // let the joint collapse finish before converge
    }).catch(function () {
      _pzSweepWatch = null;
      rows.forEach(_pzSweepUnveil);
      _pzB2Toast("Couldn't remove — try again");
    }).then(function () {
      // when a gifted-row watch is running it owns the bin lock until the
      // app/cleanup drops those rows (or its timeout)
      if (!_pzSweepWatch) _pzSweepLockBins(false);
    });
  });
}

// Case B — bundle-bin cascade watch. The theme-global handler owns the
// removal; we only paint. Re-applies veils across the cascade's section
// swaps (fresh DOM each time) until no affected rows remain or timeout.
let _pzSweepWatch = null;
function _pzSweepWatchMatches(row) {
  if (!_pzSweepWatch) return false;
  // Race-proof (QA 21 Jul): rows whose removal is in flight are tracked by KEY —
  // a mid-ceremony re-render (in-flight update / funnel reconcile, routine on
  // mobile) swaps the veiled row for a fresh unveiled one; the watch observer
  // re-veils it here until it is actually gone. Reproduced + verified in-browser.
  if (_pzSweepWatch.keys && row.dataset.itemKey && _pzSweepWatch.keys.indexOf(row.dataset.itemKey) !== -1) return true;
  if (_pzSweepWatch.tid && row.getAttribute('data-item-time-id') === _pzSweepWatch.tid) return true;
  // Freeze fix (22 Jul): the gifted/set-brush matchers below are CASCADE-ONLY.
  // They were written when a watch could only exist during a brush/bundle
  // cascade; once keys-only watches ran on EVERY removal (race-proofing),
  // these unconditional branches veiled the palette + set-brush rows on any
  // unrelated bin (the frozen REMOVING… on quad+brush). Keys-only watches now
  // match nothing but their own keys.
  if (!_pzSweepWatch.cascade) return false;
  if (row.dataset.pzGifted === '1') return true;
  const vid = row.dataset.itemKey ? parseInt(row.dataset.itemKey.split(':')[0], 10) : NaN;
  return vid === 43612451995757; // set brush is orphan-cleaned with the set
}
function _pzSweepWatchTick() {
  if (!_pzSweepWatch) return;
  const region = document.querySelector('m-cart-drawer-items');
  if (!region) return;
  const rows = [].slice.call(region.querySelectorAll('[data-cart-item]')).filter(_pzSweepWatchMatches);
  if (rows.length === 0 || Date.now() > _pzSweepWatch.until) {
    // Freeze fix (22 Jul): unveil any survivors BEFORE dropping the watch — a
    // row that never left (failed POST, app re-assert) must not keep a frozen
    // REMOVING… veil until some unrelated re-render replaces it.
    rows.forEach(_pzSweepUnveil);
    _pzSweepWatch = null;
    _pzSweepLockBins(false);
    _pzAnnounce('Items removed');
    return;
  }
  rows.forEach(_pzSweepVeil);
  region.classList.add('pz-sweep-lock');
}
document.addEventListener('click', function (e) {
  if (!e.target.closest) return;
  const bin = e.target.closest('m-cart-drawer-items .remove_bundle_product');
  if (!bin) return;
  const row = bin.closest('[data-cart-item]');
  _pzSweepWatch = {
    tid: (row && row.getAttribute('data-item-time-id')) || null,
    until: Date.now() + 6000,
    cascade: true
  };
  _pzAnnounce('Removing your set');
  _pzSweepLockBins(true);
  _pzSweepWatchTick();
}, true); // capture-phase: paints BEFORE the jQuery removal handler, never blocks it
function _pzSweepInit() {
  const region = document.querySelector('m-cart-drawer-items');
  if (!region) return;
  new MutationObserver(function () { _pzSweepWatchTick(); }).observe(region, { childList: true, subtree: true });
}
// This file loads lazily post-interaction — DOMContentLoaded may already be gone.
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', _pzSweepInit);
else _pzSweepInit();

window.pzB2Remove = function (cartEl, lineIndex) {
  try {
    // Primary resolution: the bin's own id (always carried the correct index)
    // → closest row. The [data-index] row lookup is the fallback — it was the
    // ONLY resolution before, and rows stamped data-index="" (forloop.index is
    // undefined inside a render'd snippet), so this function never matched and
    // every bin tap silently took the legacy path. Now fixed on both ends.
    const removeBtn = document.getElementById('MinimogCartDrawer-Remove-' + lineIndex);
    const lineEl = (removeBtn && removeBtn.closest('[data-cart-item]')) ||
      document.querySelector('m-cart-drawer-items [data-cart-item][data-index="' + lineIndex + '"]');
    if (!lineEl || !lineEl.dataset.itemKey) return false; // → legacy fallback
    const key = lineEl.dataset.itemKey;
    const titleEl = lineEl.querySelector('.m-cart-item__title');
    const title = ((titleEl && titleEl.textContent) || 'Item').trim().replace(/\s+/g, ' ');
    const vid = parseInt(key.split(':')[0], 10);

    const rows = [lineEl];
    const updates = {};
    updates[key] = 0;
    let startMsg = 'Removing ' + title;
    let endMsg = title + ' removed';

    // Cascade: the set brush takes its free palette with it. The palette is
    // an APP-MANAGED line (EasyGift actively re-asserts it — it runs its own
    // /cart/add.js?_easygift_internal traffic while the brush qualifies), so
    // a combined POST that includes its key can race the app: the gift line's
    // key rotates and the WHOLE update 422s → nothing removed (the desktop
    // "bugs out, everything still in basket" failure). So: remove ONLY the
    // brush — a line we own, single key, can't go stale — and let the palette
    // fall via EasyGift + the proven orphan cleanup (flow A: brush absent →
    // _Gifted removed). The palette row stays VEILED across the cascade's
    // re-renders via the sweep-watch until it's actually gone.
    if (vid === 43612451995757) {
      const gifted = [].slice.call(document.querySelectorAll('m-cart-drawer-items [data-pz-gifted="1"]'));
      if (gifted.length) {
        gifted.forEach(function (r) { rows.push(r); });
        startMsg = 'Removing The Double Brush and your free palette';
        endMsg = 'The Double Brush and free palette were removed';
        _pzSweepWatch = { tid: null, until: Date.now() + 8000, cascade: true }; // keeps _Gifted rows veiled + bins locked until the app/cleanup drops them
      }
    }

    _pzSweepRemove(rows, updates, startMsg, endMsg);
    return true;
  } catch (_) {
    return false; // any unexpected shape → legacy flow handles it
  }
};

const PZ_QTY_LOCKED_VARIANTS = [43612451995757, 41968089989229];
let _pzClampRunning = false;
function pzClampLockedQty(cart) {
  if (_pzClampRunning || !cart || !Array.isArray(cart.items)) return;
  // STEP 4: _pzSetOffer bronzer (set-offer product 15356509913197) is once-per-offer
  // too — a second bronzer is a normal separate purchase (PDP line on the
  // regular product 3950068531309, no property, full price).
  const over = cart.items.find(i => (PZ_QTY_LOCKED_VARIANTS.indexOf(i.variant_id) !== -1
      || (i.properties && i.properties._pzSetOffer && i.product_id === PZ_BRONZER_PRODUCT_ID)) && i.quantity > 1);
  if (!over) return;
  _pzClampRunning = true;
  fetch('/cart/change.js', {
    method: 'POST', credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'xmlhttprequest' },
    body: JSON.stringify({ id: over.key, quantity: 1 })
  }).then(resp => {
    if (resp.ok && window.cartDrawer && typeof window.cartDrawer.onCartDrawerUpdate === 'function') {
      try { window.cartDrawer.onCartDrawerUpdate(); } catch (_) {}
    }
  }).catch(() => {}).finally(() => {
    setTimeout(() => { _pzClampRunning = false; }, 600);
  });
}

// Get the progress bar element
// Get the progress bar element

// const PprogressBar = document.getElementById('shipping-progress');
// const cartCurrency = PprogressBar.dataset.cartcurrency;
// const shippingval = PprogressBar.dataset.shippingval;

// function updateProgressBar(value, minOrderValueGift) {

//   if (value >= minOrderValueGift) {
//     PprogressBar.value = value;
//   } else {
//     console.log(PprogressBar.value);
//     console.log(shippingval);
 
//     if(shippingval > PprogressBar.value){
//       if(cartCurrency == 'EUR'){
//         PprogressBar.value = value - 1500;
//       }else{
//         PprogressBar.value = value - 300;
//       } 
//     }else{
//       PprogressBar.value = value;
//     }
    
//   }
// }





function c_remove(prodID) {
  console.log('-------------------------------------------------------------------------');
  console.log(prodID);
  console.log('-------------------------------------------------------------------------');
 
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {'quantity' : 0, 'id': prodID},
    success: function (data) 
    {
       window.cartDrawer.onCartDrawerUpdate();
    
    },
    error: function(err) {console.log(err)}
  });

  
}

function customMsg(txt, PriceCart) {

  const linkd = document.querySelector('#valFreeShip');
  var minOrderValueShipping = linkd.getAttribute('data-freeshipment');
  var examples = document.querySelectorAll(".add_custom_txt");
  if(PriceCart >= minOrderValueShipping){
   
    examples.forEach(example => {
    example.innerHTML = '';
  });
  }else{
    examples.forEach(example => {
    example.innerHTML = txt;
  });
  }
  
 

  
}


// $('m-cart-drawer .checkout_cart_btn').on('click',  function(e){
  
//   e.preventDefault();
//   fetch('/cart.js')
//     .then((resp) => resp.json())
//     .then((cart) => {

//        var freeGiftLabel = document.querySelector('#freeGiftLabel');
//         var giftProductId = freeGiftLabel.getAttribute('data-freegiftId');
//   cart.items.forEach(function(product, index) { 
    
//        if(giftProductId == product.product_id){
         
//               window.location.href ='/checkout';
      
         
//        }else{
//           var hasCls = document.querySelector('.free_gift_wrp button.m-add-to-cart');
          
//          if(hasCls.classList.contains('deactivate')){
//            window.location.href ='/checkout';
//          }else{
//            if(hasCls.classList.contains('activate')){
//               document.querySelector(".sure-nogift").classList.add("active");
             
//            }
//          }
         
         
//        }
//      });
//     });
// });

//  $('body').on('click', '.choose .no', function (e) {
//     e.preventDefault();
//     $('.sure-nogift').removeClass('active');
//     $('body').addClass('hili');
//     $('m-cart-drawer-items').animate({scrollTop: 0}, 200);
//     setTimeout(function(){
//         setTimeout(function(){
//             $('body').removeClass('hili');
//         },1500);
//     },500);
// });

